export default {
  headers: {
    edit_time: 'Rediger tid',
    create_time: 'Opret tid',
  },
  labels: {
    select_all: 'Vælg alle',
  },
  buttons: {
    add_opening_time: 'Tilføj åbningstid',
    add: 'Tilføj',
    cancel: 'Annuller',
  },
};
